'use strict';

function ScrollingUtilities() {
  this.init = function () {
    this._attachSmoothScroll();
  };

  this.initAllReady = function () {};

  this._attachSmoothScroll = function () {
    var _this = this;
    $(document).on('click', 'a[href^=#].js--smooth-scroll, a[href^=#].js--smooth-scroll-anchored', function (event) {
      var $navigationElement = $('#Navigation');
      var $dropdownElement = $('.marketing-nav__submenu-dropdown');
      var $anchorElement = $(this);
      var $anchorTarget = $($anchorElement.attr('href'));
      var scrollOffset = 0;

      // Todo: Make the media query detecting function available globally
      if ($navigationElement.length) {
        if ($dropdownElement.length && $navigationElement.css('content').replace(/["']/g, '') === 'large') {
          scrollOffset = $navigationElement.outerHeight() + $dropdownElement.outerHeight() - 1;
        } else {
          scrollOffset = $navigationElement.outerHeight() - 1;
        }
      }

      if (!$anchorElement.is('.js--smooth-scroll-anchored')) event.preventDefault();

      $anchorElement.blur();

      _this._smoothScroll($anchorTarget, scrollOffset, 500);
    });
  };

  this._smoothScroll = function ($anchorTarget, scrollOffset, duration) {
    /*
      We call the smooth scroll function recursively in case the page height
      has changed while we were scrolling.
       TODO: Inject the proper image height/width so the recursive call is
      unnecessary
    */
    var _this = this;
    $('html, body').animate({
      scrollTop: $anchorTarget.offset().top - scrollOffset
    }, duration, 'linear').promise().then(function () {
      var elementTop = Math.ceil($anchorTarget.offset().top);
      var windowTop = Math.ceil($(window).scrollTop());
      var scrollCorrection = elementTop - windowTop;

      if (Math.abs(scrollCorrection) > scrollOffset + 1) {
        _this._smoothScroll($anchorTarget, scrollOffset, scrollCorrection / 10);
      }
    });
  };
}